import { TranslationBundle } from "./TranslationBundle.js";
import { v4 as uuid } from 'uuid';
export class OrderItemAddon {
    id;
    name = null;
    price = 0;
    constructor(id, data) {
        this.id = id || uuid();
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                        if (key == 'name') {
                            value = value ? new TranslationBundle(value) : null;
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
}
export class OrderItemOptionValue {
    id;
    name = null;
    correction = 0;
    constructor(id, data) {
        this.id = id || uuid();
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                        if (key == 'name') {
                            value = new TranslationBundle(value);
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
}
export class OrderItemOption {
    id;
    name = null;
    values = [];
    constructor(id, data) {
        this.id = id || uuid();
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                        if (key == 'values' && Array.isArray(value)) {
                            value = value.map((v) => new OrderItemOptionValue(v && v.id, v));
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
            //backward compat: legacy persisted shape used a single `value`
            if ((!this.values || this.values.length === 0) && data.value) {
                this.values = [new OrderItemOptionValue(data.value.id, data.value)];
            }
        }
    }
}
export class OrderItemSlotItem {
    productId;
    correction = 0;
    name;
    constructor(name, productId, correction) {
        this.productId = productId;
        this.name = name;
        this.correction = correction;
    }
}
export class OrderItemSlot {
    id;
    name;
    chosen;
    constructor(id, name, chosen) {
        this.id = id || uuid();
        this.name = name;
        this.chosen = chosen;
    }
}
export class ServiceInformation {
    note = null;
    courseId = null;
}
export class OrderItem {
    id;
    productId = null;
    quantity = 0;
    note = null;
    courseId = null;
    options = [];
    addons = [];
    chosen = {};
    name = null;
    vatRate = 0;
    //price with addons prices, option prices and chosen subprodukt correction
    price = 0;
    //price with without any additional fees, to check if price has changed
    basePrice = 0;
    serviceInformation = null;
    constructor(id, data) {
        this.id = id || uuid();
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                        if (key == 'options' && value.length > 0) {
                            let items = [];
                            for (let item of value) {
                                items.push(new OrderItemOption(item.id, item));
                            }
                            value = items;
                        }
                        if (key == 'addons' && value.length > 0) {
                            let items = [];
                            for (let item of value) {
                                items.push(new OrderItemAddon(item.id, item));
                            }
                            value = items;
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
}
